/* ============================================
   QN — FIX CARRITO VACIO · 16/09/2026
   ============================================

   PROBLEMA
   --------
   QN-NEW-cart-drawer.js abria el drawer con un temporizador fijo de 700 ms
   despues del click en "Agregar", sin esperar a que /cart/add.js terminara.
   En una visita nueva en celular (sin cache, 4G) ese pedido tarda mas de
   700 ms, asi que el drawer se abria mostrando "Tu carrito esta vacio".
   A la segunda vez ya habia carrito y aparecian los dos productos.

   Ademas fetchCart() devolvia la copia vieja del carrito si ya habia un
   pedido en curso, en vez de esperar al que estaba corriendo.

   SOLUCION
   --------
   1. fetchCart() devuelve la promesa en curso en vez de datos viejos.
   2. scheduleAutoOpen() consulta el carrito hasta que la cantidad sube
      (o hasta un techo de ~6 s) y recien ahi abre el drawer.

   Se aplica como parche sobre window.QNCartDrawer para no tocar el archivo
   original. Para revertir, alcanza con sacar este archivo del theme.liquid.
   ============================================ */

(function () {
  'use strict';

  function apply(D) {
    if (!D || D.__qnFixApplied) return;
    D.__qnFixApplied = true;

    D.refreshPromise = null;

    // --- 1. fetchCart: esperar el pedido en curso, no devolver lo viejo ---
    D.fetchCart = function (openAfterRefresh) {
      var self = this;

      if (self.isRefreshing && self.refreshPromise) {
        return self.refreshPromise;
      }

      self.isRefreshing = true;

      self.refreshPromise = fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) { return self.normalizePromoCart(cart); })
        .then(function (cart) {
          self.currentCart = cart;
          self.refreshCart(cart);
          if (openAfterRefresh) self.open(false);
          return cart;
        })
        .catch(function (error) {
          console.error('Error fetching cart:', error);
          return null;
        })
        .then(function (cart) {
          self.isRefreshing = false;
          self.refreshPromise = null;
          return cart;
        });

      return self.refreshPromise;
    };

    // --- 2. scheduleAutoOpen: esperar a que el carrito cambie de verdad ---
    var FIRST_DELAY = 350;   // primer intento
    var STEP = 450;          // entre intentos
    var MAX_ATTEMPTS = 13;   // techo ~6 s

    D.scheduleAutoOpen = function () {
      var self = this;
      clearTimeout(self.autoOpenTimer);

      var before = (self.currentCart && typeof self.currentCart.item_count === 'number')
        ? self.currentCart.item_count
        : self.getInitialHeaderCount();

      var attempts = 0;

      function tick() {
        self.autoOpenTimer = setTimeout(function () {
          attempts++;

          self.fetchCart(false).then(function (cart) {
            var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : before;

            // El carrito cambio: abrir ya, con el contenido correcto.
            if (count > before) { self.open(false); return; }

            // Se acabo la paciencia: abrir igual para no dejar al cliente sin
            // respuesta. Si el agregado fallo de verdad, vera el carrito real.
            if (attempts >= MAX_ATTEMPTS) { self.open(false); return; }

            tick();
          });
        }, attempts === 0 ? FIRST_DELAY : STEP);
      }

      tick();
    };
  }

  function boot() {
    if (window.QNCartDrawer) { apply(window.QNCartDrawer); return; }

    // El drawer puede cargar despues; reintentar un rato corto.
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (window.QNCartDrawer) { apply(window.QNCartDrawer); clearInterval(iv); }
      else if (tries > 40) { clearInterval(iv); }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
